import { Link } from "react-router-dom";
import PageShell from "@/components/site/PageShell";
import SEO from "@/components/site/SEO";
import JsonLd, { buildBreadcrumbs } from "@/components/site/JsonLd";
import { blogPosts } from "@/data/blogPosts";
import { ArrowRight, Calendar } from "lucide-react";

export default function BlogIndex() {
  const sorted = [...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <PageShell testid="page-blog">
      <SEO
        title="Blog | Guías de viaje y transporte en Bogotá | Líneas Doradas"
        description="Guías prácticas sobre transporte grupal, destinos cerca de Bogotá y consejos para organizar tu viaje o el transporte de tu empresa."
      />
      <JsonLd
        id="breadcrumb-jsonld"
        data={buildBreadcrumbs([
          { name: "Inicio", url: "https://www.transporteenvanesybuses.com/" },
          { name: "Blog", url: "https://www.transporteenvanesybuses.com/blog" },
        ])}
      />

      <section className="relative pt-16 md:pt-24 pb-12">
        <div className="orb-gold w-[500px] h-[500px] left-[-140px] top-[80px] opacity-70" />
        <div className="max-w-5xl mx-auto px-5 md:px-8 relative">
          <div className="text-[#E8C87A] text-xs uppercase tracking-[0.35em] mb-4">Blog</div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.05] text-[#F5EFE0]">
            Guías de <span className="italic text-gold-grad">viaje y transporte</span>
          </h1>
          <p className="text-[#F5EFE0]/70 mt-5 max-w-2xl text-base md:text-lg leading-relaxed">
            Consejos prácticos para organizar tu próximo viaje, evento o el transporte de tu empresa.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-5xl mx-auto px-5 md:px-8 grid md:grid-cols-2 gap-6">
          {sorted.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="card-lux p-6 flex flex-col hover:border-[#D4AF37]/50"
              style={{ transitionProperty: "border-color", transitionDuration: "220ms" }}
            >
              <div className="flex items-center gap-2 text-xs text-[#F5EFE0]/50 mb-3">
                <Calendar size={13} />
                {new Date(post.date).toLocaleDateString("es-CO", { day: "numeric", month: "long", year: "numeric" })}
              </div>
              <h2 className="font-display text-2xl text-[#F5EFE0] mb-2">{post.title}</h2>
              <p className="text-sm text-[#F5EFE0]/60 leading-relaxed mb-4 flex-1">{post.excerpt}</p>
              <span className="text-sm text-[#E8C87A] inline-flex items-center gap-1.5">
                Leer artículo <ArrowRight size={14} />
              </span>
            </Link>
          ))}
        </div>
      </section>
    </PageShell>
  );
}
